module.exports = __webpack_public_path__ + "static/media/bg.964e602e.jpg";